export default {
  "content": "<path d=\"M18.34 12.02l2.82 2.82L22.34 16H38c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H10c-1.1 0-2-.9-2-2V14.02c0-1.1.9-2 2-2h8.34zm1.66-4H10c-3.32 0-6 2.68-6 6V34c0 3.32 2.68 6 6 6h28c3.32 0 6-2.68 6-6V18c0-3.32-2.68-6-6-6H24l-4-3.98z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};